import { render, staticRenderFns } from "./PageLoadingBar.vue?vue&type=template&id=36032124&scoped=true"
import script from "./PageLoadingBar.vue?vue&type=script&lang=ts"
export * from "./PageLoadingBar.vue?vue&type=script&lang=ts"
import style0 from "./PageLoadingBar.vue?vue&type=style&index=0&id=36032124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36032124",
  null
  
)

export default component.exports